import { CircleCheck } from 'lucide-react';

const PROPERTY_TYPES = [
  'Single Family Residence',
  'Condo, Townhome',
  'Duplex, Triplex, Fourplex',
  '5+ Unit Apartment',
];

const OCCUPANCY_CONDITIONS = [
  'Owner Occupied',
  'Leased with Tenant in Place',
  'Vacant Property, As Is',
  'Vacant Property, Renovated',
];

const HeroBanner = () => {
  return (
    <div
      className="relative w-full rounded-lg overflow-hidden"
      style={{
        backgroundImage: 'url(/static/images/for-sale.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black/70" />
      <div className="relative z-10 px-6 py-8 md:px-10 text-white text-center">
        <h1 className="font-raleway text-data-card-3xl font-bold mb-8">
          Sell your Property with Marshall Reddick
        </h1>
        <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-16">
          <div className="text-left">
            <p className="text-data-card-xl font-bold mb-3">Property Type</p>
            <ul className="space-y-2">
              {PROPERTY_TYPES.map((item) => (
                <li key={item} className="flex items-center gap-2 text-data-card-xl">
                  <CircleCheck className="w-7 h-7 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="text-left">
            <p className="text-data-card-xl font-bold mb-3">Occupancy/Condition</p>
            <ul className="space-y-2">
              {OCCUPANCY_CONDITIONS.map((item) => (
                <li key={item} className="flex items-center gap-2 text-data-card-xl">
                  <CircleCheck className="w-7 h-7 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export { HeroBanner };
